import Component from '@component';

export default class ClickDiscoverLoyaltyProgram extends Component {
	onInit(el) {
		this.el = el;

		const userDiscoverLoyalty = {};
		userDiscoverLoyalty.event = 'loyalty_discover';

		if (window.sessionStorage.getItem('userDiscoverLoyalty') === 'yes') {
			window.sessionStorage.removeItem('userDiscoverLoyalty');
			dataLayer.push(userDiscoverLoyalty);
		}
	}

	onReady() {
		if (window.sessionStorage.getItem('userDiscoverLoyalty') === 'yes') {
			window.sessionStorage.removeItem('userDiscoverLoyalty');
		}
		this.el.addEventListener('click', this.clickOnLoyaltyProgram.bind(this));
	}

	clickOnLoyaltyProgram() {
		window.sessionStorage.setItem('userDiscoverLoyalty', 'yes');
	}
}
